import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { retry, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { SearchRequest, TankmixTest, SeedTreatmentSearchRequest } from '../models/searchRequest';
import { TankmixRequest, Ingredient } from '../models/tankmixRequest';
import { Observable } from 'rxjs';
import { NameId } from '../models/name-id';
import { NamedId } from '../models/NamedId';
import { APIPortResolver } from 'src/environments/APIPortResolver';
@Injectable({
  providedIn: 'root'
})
class IdentityToken {
  header: any;
  payload: any;
  signature: string;
}
@Injectable()
export class ApiService {
  
  apiPath: string;;
  idToken: IdentityToken;
  private maxRetries: 0;
  constructor(private http: HttpClient) {
    this.apiPath=APIPortResolver.resolve()+'tankmix/';
  
  }
  
  storeNewIdToken(idtoken: string) {
    const splits = idtoken.split('.');
    this.idToken = new IdentityToken();
    this.idToken.header = JSON.parse(atob(splits[0]));
    this.idToken.payload = JSON.parse(atob(splits[1]));
    this.idToken.signature = splits[2];

  }
  getCountries() {
    console.log(this.apiPath + 'countries');
    return this.http.get(this.apiPath + 'countries');
  }
  getLanguages() {
    return this.http.get(this.apiPath + 'languages');
  }
  getActiveIngredients() :Observable<NameId[]>{
    return this.http.get<NameId[]>(this.apiPath + 'active-ingredients');
  }
  getHelenaProducts() {
    return this.http.get(APIPortResolver.resolve()+'helena/products/');
  }
 
  getYaraProducts(countryCode: string) : Observable<NamedId[]> {
    return this.http.get<NamedId[]>(this.apiPath + 'products/' + countryCode);
  }
  getOutcome(tankmixId: string, languageCode:string, countryCode: string): Observable<TankmixTest> {
    console.log(this.apiPath + 'outcome/' + tankmixId +'/'+ languageCode + '/' + countryCode);
    return this.http.get<TankmixTest>(this.apiPath + 'outcome/' + tankmixId +'/'+ languageCode + '/' + countryCode);
  }
  getagrochemicals() :Observable<NameId[]> {
    return this.http.get<NameId[]>(this.apiPath + 'agrochemicals');
  } 
  getAgrochemicalsTestedWith(countryId:string, chemicalId:string):Observable<NameId[]> {
    return this.http.get<NameId[]>(  `${this.apiPath}agrochemicals-tested-with/${countryId}/${chemicalId}`);
  }
  getActivesTestedWith(countryId:string, chemicalId:string):Observable<NameId[]> {
    return this.http.get<NameId[]>(  `${this.apiPath}actives-tested-with/${countryId}/${chemicalId}`);
  }
  search(searchRequest: SearchRequest): Observable<TankmixTest[]> {
    return this.http.post<TankmixTest[]>(this.apiPath + 'search', searchRequest)   
      ;
  }
  searchSeedTreatments(searchRequest: SeedTreatmentSearchRequest): Observable<TankmixTest[]> {
    
    console.log(searchRequest);
    return this.http.post<TankmixTest[]>(this.apiPath + 'seed-search', searchRequest)
     
    ;
  }
  submitRequest(tankmixRequest: TankmixRequest, html: string) {
    return this.http.post(this.apiPath + 'tankmix-request',
      {
        html,
        request: tankmixRequest,
        requestor: tankmixRequest.email
      },
    )
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.');
  }
}
